import React from 'react'
import { StackScreenProps } from '@react-navigation/stack'
import { ScreenWrapper } from '../../../@ui/containers/grid/screen.wrapper'
import { Text } from 'react-native-paper'
import { ContributionList } from './components/contribution.list'
import { useGlobalStyles } from '../../../contexts/global-styles.provider'
import { AppNavigatorParams } from '../../../navigation/types'

export function UserContributionsScreen({
  route,
  navigation,
}: StackScreenProps<AppNavigatorParams, 'UserContributions'>) {
  const { contributions, title } = route.params
  const globalStyles = useGlobalStyles()

  return (
    <ScreenWrapper withScrollView={false} style={globalStyles.pageContainer}>
      <Text
        style={{ marginVertical: 20, textAlign: 'center' }}
        variant={'headlineSmall'}
      >
        {title}
      </Text>
      <ContributionList
        contributions={contributions}
        hideFilters={true}
        type={'All'}
        status={'All'}
        onContributionPress={(contribution) => {
          navigation.navigate('PerspectiveContribution', {
            contributionId: contribution.id,
          })
        }}
      />
    </ScreenWrapper>
  )
}
export default UserContributionsScreen
